// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"a2e27525","508":"fce8e98e","629":"a6fc9f5f","776":"6011c26d"}[chunkId] + ".chunk.js";
};